import PropTypes from 'prop-types';
import { NewBookingDeliveryPropType } from 'common/prop-types';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import I18n from 'i18n-js';
import _get from 'lodash/get';
import { deliveriesFromPropsSelector } from 'selectors/new-booking-selectors';
import SingleDeliveryGuarantee from 'components/v2/insurance/single-delivery-guarantee';
import MSDDeliveryGuarantee from 'components/v2/insurance/msd-delivery-guarantee';
import useInsuranceHook from 'components/v2/insurance/hook';
import styles from 'components/v2/insurance/delivery-guarantee.less';
import OverlayBody from '../overlay-body';

const BulkDeliveryGuaranteePanel = ({ onClose, deliveryIDs, deliveries }) => {
  const onConfirm = useCallback(
    () => {
      onClose();
    },
    [onClose],
  );

  const onBack = useCallback(
    () => {
      onClose();
    },
    [onClose],
  );

  const { onChange, onResetAll, deliveriesInsuranceDetails } = useInsuranceHook(
    deliveryIDs,
    deliveries,
  );
  const {
    totalDisplayPrice,
    allSameOption,
    totalNonIncludedSelected,
  } = deliveriesInsuranceDetails;

  const isOneMSD =
    deliveries.length === 1 &&
    _get(deliveries, '[0].detail.dropOffs.length', 1) > 1;
  const showDisplayPrice =
    totalDisplayPrice && (isOneMSD || (deliveries.length > 1 && allSameOption));

  return (
    <OverlayBody
      showConfirm
      onConfirmClick={onConfirm}
      showHeader
      showTitle
      title={I18n.t('v2.anytimeBooking.insurance.editDeliveryGuarantee')}
      showClose
      onClose={onBack}
      showFooter
      footer={
        showDisplayPrice && (
          <div className={styles.totalDeliveryGuarantee}>
            <span>
              {I18n.t('v2.anytimeBooking.insurance.totalDeliveryGuarantee')}
            </span>
            <span className={styles.totalPrice}>{totalDisplayPrice} </span>
          </div>
        )
      }
      showSecondaryCTA={totalNonIncludedSelected > 0}
      onSecondaryCTA={onResetAll}
      secondaryCTAText={I18n.t('v2.anytimeBooking.insurance.removeForAll')}
    >
      {isOneMSD ? (
        <MSDDeliveryGuarantee
          onChange={onChange}
          delivery={deliveries[0]}
          deliveriesInsuranceDetails={deliveriesInsuranceDetails}
        />
      ) : (
        <SingleDeliveryGuarantee
          onChange={onChange}
          deliveries={deliveries}
          deliveriesInsuranceDetails={deliveriesInsuranceDetails}
        />
      )}
    </OverlayBody>
  );
};

BulkDeliveryGuaranteePanel.propTypes = {
  onClose: PropTypes.func.isRequired,
  deliveryIDs: PropTypes.arrayOf(PropTypes.string).isRequired,
  deliveries: PropTypes.arrayOf(NewBookingDeliveryPropType).isRequired,
};

export default connect((state, props) => ({
  deliveries: deliveriesFromPropsSelector(state, props),
}))(BulkDeliveryGuaranteePanel);
